import { Context } from "@silvertours/front-shared";
var hasContext = Context.guardContext;
var usePath = function() {
    var pathContext = Context.useClientContext("path");
    hasContext("path", pathContext);
    var _value = pathContext.value, alternatives = _value.alternatives, current = _value.current;
    var isHomepage = current.startsWith("index.");
    var currentPath = isHomepage ? "" : current;
    return {
        alternatives: alternatives,
        current: currentPath,
        isHomepage: isHomepage
    };
};
export { usePath };
